'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  position: relative;\n  background: ', ';\n'], ['\n  ', ';\n  position: relative;\n  background: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

var _Button = require('../../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var reverse = _ref.reverse;
  return reverse ? 'padding-left: 20px;' : 'padding-right: 20px;';
}, _colors.white);

var More = function More(_ref2) {
  var onClick = _ref2.onClick,
      loading = _ref2.loading,
      reverse = _ref2.reverse;
  return _react2.default.createElement(Container, {
    reverse: reverse
  }, _react2.default.createElement(_Button2.default, {
    theme: 'grey',
    loading: loading,
    onClick: onClick,
    icon: 'ellipsis1',
    outline: true
  }));
};

More.propTypes = {
  onClick: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  reverse: _propTypes2.default.bool
};
exports.default = More;